// This component serves as a wrapper around each Form and decides whether to show or hide the
// form based on the current step.

import { Container } from "@material-ui/core";
import settings from "@styles/settings";
import React from "react";

const StepBody = (props: {
  children: React.ReactChild | React.ReactChild[];
  roomForNavigationButtons?: boolean;
}) => {

  const roomForNavigationButtons = props.roomForNavigationButtons ?? true;
  const navigationButtonsBarHeight = roomForNavigationButtons ? settings.navigationButtonsBarHeight : "0px"

  return (
    // this div hides and shows the StepBody
    <div
      style={{
        // minHeight: `calc(100vh - ${settings.navBarHeight} - ${navigationButtonsBarHeight})`,
        minHeight: `calc(100vh - ${navigationButtonsBarHeight} - ${settings.navBarHeight})`,
        // paddingTop: settings.navBarHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md">{props.children}</Container>
    </div>
  );
};

export default StepBody;
